<template>

  <!--人物图片推荐-->
  <div v-if="userTui==0">
    <div class="alert-box person-red-envelopes person-recommend">
      <p @click="closeFun" class="mask"></p>
      <div class="alert-box-con-red">
        <img class="red-envelopes-img" :src="recommendPerson.img" alt="">
        <img class="red-envelopes-logo" src="../assets/red-envelopes-logo.png" alt="">

        <div class="person-red-envelopes-bot border-box">
          <img @click="closeFun" class="red-envelopes-close" src="../assets/red-envelopes-close.png" />
          <div class="person-red-envelopes-con">
            <p class="person-red-envelopes-text1 border-box hide">{{ recommendPerson.sellprice }}元听全部景点解说</p>
            <p class="person-red-envelopes-text2 border-box hide">{{ recommendPerson.name }}</p>
            <p class="person-red-envelopes-btn" @click="goVideoPlay(recommendPerson.bid)">立即收听</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--视频推荐-->
  <div v-else="userTui==2">
    <div class="guide-video">
      <img class="video-close" @click="pauseVideo()" src="../assets/red-envelopes-close.png" alt="">
      <div class="guide-video-con" @click="playVideo()">
          <video id="videoPlay" :src="recommendPerson.video" :poster="recommendPerson.img" preload="auto"
                 webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"></video>
          <img class="guide-play"  src="../assets/guide-play.png" alt="" v-show="isVideoPlay==false">
          <p class="guide-btn" @click.stop="goVideoPlay(recommendPerson.bid)" v-if="recommendPerson.bid">听TA讲解</p>
      </div>
    </div>
  </div>

</template>

<script>

  import {getCouponAtRandom} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
        isVideoPlay: false,  //视频没有在播放
        Video: '', //视频Dom
      }
    },
    created(){

    },
    props: ['recommendPerson','shopid','userTui'],
    computed: {

    },
    methods: {
      //关闭弹窗
      closeFun(){
        this.$emit('close',{redEnvelopes: [], personEnvelopes: [], recommendPerson: "",recommendYear: ""});
      },

      //跳转到专辑详情页
      goVideoPlay(id){
        this.$router.push({
          path: `/video-play?${'id='+ id +'&spotid=&shopid='+ this.shopid + '&TimeStamp='+ this.TimeStamp}`
        });
      },

      //新增视频播放
      playVideo(){
        this.Video = document.getElementById("videoPlay");
        if (this.Video.paused) {
          this.Video.play();
          this.isVideoPlay = true;
          this.timeUpdate();
          if(this.Video.readyState != 4){
            this.$loading.show('视频加载中');
          }
        } else {
          this.Video.pause();
          this.isVideoPlay = false;
        }
      },
      pauseVideo(){
        this.Video = document.getElementById("videoPlay");
        this.Video.pause();
        this.closeFun();
      },
      timeUpdate(){
        let self = this;

        var videoTimer = setInterval(function () {
          if(self.Video.currentTime > 0){
            self.$loading.hide();

            clearInterval(videoTimer);
          }
        }, 1000);
      },

    },
  }
</script>

<style scoped>

  @import '../style/alert';

  /*视频弹窗*/
  .guide-video{position: fixed;top:0;left: 0;width: 100%;height: 100%;background:rgba(0,0,0,.56);z-index: 99;text-align: center;}
  .guide-video-con{position: absolute;top:45%;left: 50%;width: 90%;height: 80%;border-radius: .12rem;background: none;transform: translate(-50%,-50%);}
  .guide-play{position: absolute;top:50%;left: 50%;width: 1.08rem;height: 1.08rem;transform: translate(-50%,-50%);z-index: 9;}
  .guide-play.curr{display: block;}
  .guide-video-con video{display: block;height: 100%; max-width: 100%; margin: 0 auto;border-radius: .12rem; }
  .video-close{position: absolute;left: 50%;width: .6rem;height: .6rem;margin-left: -.3rem;bottom: 1.5%;}
  .guide-btn{ width: 80%; height: .76rem; margin: .1rem auto 0; font: .28rem/.76rem "Microsoft YaHei"; color: #fff; letter-spacing: .07rem; background-color: #ffb505;border-radius: .12rem; }

</style>



// WEBPACK FOOTER //
// src/components/AlertRecommendPerson.vue